import React, { useState, useMemo, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
} from "@mui/material";
import _ from "lodash";
import ReactJson from 'react-json-view';

const ErrorModel = ({ open, onClose, errorMessage, topicKey }) => {

  const bindData = (val) => {
    try {
      const splitArr = _.split(val, '\n');
      const arr = _.map(_.filter(splitArr, ob =>{ return _.trim(ob)}), it => {
        const ar = _.split(it, ':');

        return ar?.length > 1 ? { [ar[0]]: JSON.parse(_.join(_.filter(ar, (it, i) => { return i > 0 }), ':')) } : {}
      })

      return arr;

    } catch (e) {
      return val // error in the above string (in this case, yes)!
    }
  }
  const output = React.useMemo(() => bindData(errorMessage), [errorMessage])
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Error</DialogTitle>
      <Divider />
      <DialogContent>
        {typeof (output) === 'string' &&
          output
        }
        {typeof (output) !== 'string' &&
          <ReactJson src={output} key={'text'} displayDataTypes={false} name={false} />

        }</DialogContent>
      <Divider />
      <DialogActions
        sx={{ display: "flex", justifyContent: "start", my: 1, px: 3 }}
      >
        <Button
          onClick={onClose}
          size="small"
          variant="outlined"
          color="error"
        // sx={{ ml: 2 }}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModel;
